// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../../types';

type Props = {
  checked: boolean,
  disabled?: boolean,
  error?: ?boolean,
};

const StyledBox = styled<any, Theme, Props>('div')`
  font-size: 1.125rem;
  width: 1em;
  height: 1em;
  background: #fff;
  border-radius: 0.125em;
  border-style: solid;
  border-color: ${props => (props.error
    ? props.theme.form.checkbox.borderColorError
    : props.theme.form.checkbox.borderColor)};
  border-width: ${props => (props.error ? '2px' : '1px')};
  padding: 0.1em;
  box-sizing: border-box;
  margin-right: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  ${props => props.checked && css`
    border-color: transparent;
    background-color: ${props.theme.form.selected};
  `}
  ${props => props.disabled && css`
    background: ${props.theme.form.checkbox.disabledBackgroundColor};
  `}
`;

export default StyledBox;
